export default "__VITE_ASSET__BdaB_tMm__"